// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".start-option[data-v-811c5b32] {\n  width: 230px;\n  border: 1px solid #BED1DA;\n  border-radius: 8px;\n}\n.v-tooltip__content[data-v-811c5b32] {\n  background-color: #303033;\n}", ""]);
// Exports
module.exports = exports;
